<div class="layout" [class.no-clickable]="lockUserInteraction">
  <div class="layout__page">
    <qb-ita-header
      logoImage="/assets/img/logos/verti.png"
      [isLogoClickable]="true"
      [headerText]="'HEADER.TEXT' | translate"
      [promotionalImage]="partnershipImage$ | async"
      [promotionalUrl]="(partnershipUrl$ | async) || headerPromotionalUrl"
      [promotionalAlt]="promotionalAlt"
      [headerPromotionalShowInd]="headerPromotionalShowInd"
      [vertiUrl]="vertiUrl$ | async"
    ></qb-ita-header>
    <div class="layout__scroll-container" [ngClass]="{ button__mobile: !hideNextButtonMobile && !hideNextButton }">
      <div class="layout__container">
        <div *ngIf="chatAvailable">
          <div style="position: absolute; right: 40px">
            <qb-ita-genesys-chat [visibleInd]="chatAvailable" [chatConfig]="genesysChatConfig"></qb-ita-genesys-chat>
          </div>
        </div>
        <div
          class="layout__content"
          [ngClass]="{ 'layout__content--center': contentCentered, 'layout__content--padding': contentPadding }"
        >
          <div class="form-wrapper">
            <div role="navigation">
              <ng-container *ngIf="showSteps && steps?.length && currentStep">
                <qb-ita-step
                  class="layout__steps--desktop"
                  [steps]="steps"
                  [currentStep]="currentStep"
                  [percent]="percent"
                ></qb-ita-step>
                <div class="layout__steps--container">
                  <ng-container *ngTemplateOutlet="backButton; context: { hideTextMobile: true }"></ng-container>
                  <qb-ita-circle-progress-bar
                    class="layout__steps--mobile"
                    [steps]="steps"
                    [currentStep]="currentStep"
                    [percent]="percent"
                  ></qb-ita-circle-progress-bar>
                </div>
              </ng-container>
              <!-- If there are no steps, back button should show the text label -->
              <ng-container *ngIf="!(showSteps && steps?.length && currentStep)">
                <ng-container *ngTemplateOutlet="backButton; context: { hideTextMobile: false }"></ng-container>
              </ng-container>
            </div>

            <main role="main">
              <div class="layout__form" [ngClass]="{ footer__bottom: !hideNextButtonMobile && !onDesktop }">
                <h1 *ngIf="stepName" class="sr-only">{{ replaceHyphensWithSpaces(stepName) }}</h1>
                <ion-grid *ngIf="showSummaryLite" class="layout__summary--mobile">
                  <ion-row>
                    <ion-col size="12" *ngIf="showWebChannelAlert">
                      <ng-container *ngTemplateOutlet="alert"></ng-container>
                    </ion-col>
                    <ion-col size="12">
                      <ng-container *ngTemplateOutlet="coveragesLite"></ng-container>
                    </ion-col>
                  </ion-row>
                </ion-grid>
                <div *ngIf="stepPageTitle || stepPageDescription" class="layout__header">
                  <ion-icon
                    *ngIf="stepPageIcon"
                    class="{{ stepPageIcon }} layout__icon color--secondary3"
                    [attr.aria-label]="'ACCESSIBILITY.ICON.HOUSE' | translate"
                  ></ion-icon>
                  <h2 *ngIf="stepPageTitle" class="layout__title text--24 text--bold">{{ stepPageTitle }}</h2>
                  <h3 *ngIf="stepPageDescription" class="layout__subtitle text--16">
                    <span [innerHtml]="stepPageDescription | qbItaSafeHtml"></span>
                  </h3>
                </div>
                <ion-grid class="full-width">
                  <ion-row>
                    <ion-col size="12" [attr.size-md]="showSummaryLite ? 8 : 12">
                      <ng-content></ng-content>
                      <qb-ita-button
                        *ngIf="!hideNextButton && showSummaryLite"
                        class="layout__next-button"
                        [label]="nextBtnTitle || ('CONTINUE_BUTTON.TITLE' | translate)"
                        (btnClick)="nextBtnClick.emit()"
                        buttonPosition="right"
                        [disabled]="nextBtnDisabled"
                        [showSpinner]="nextButtonShowSpinner"
                      ></qb-ita-button>
                    </ion-col>
                    <ion-col size-md="4" *ngIf="showSummaryLite" class="layout__summary">
                      <ion-row>
                        <ion-col size="12" *ngIf="showWebChannelAlert">
                          <ng-container *ngTemplateOutlet="alert"></ng-container>
                        </ion-col>
                        <ion-col size="12">
                          <ng-container *ngTemplateOutlet="coveragesLite"></ng-container>
                        </ion-col>
                      </ion-row>
                    </ion-col>
                  </ion-row>
                </ion-grid>
                <qb-ita-button
                  *ngIf="!hideNextButton && !showSummaryLite"
                  class="layout__next-button"
                  [label]="nextBtnTitle || ('CONTINUE_BUTTON.TITLE' | translate)"
                  (btnClick)="nextBtnClick.emit()"
                  [buttonPosition]="nextBtnPosition || 'center'"
                  [disabled]="nextBtnDisabled"
                  [showSpinner]="nextButtonShowSpinner"
                ></qb-ita-button>
              </div>
            </main>
          </div>
        </div>
        <ng-container *ngIf="footerLinks$ | async as footerLinks">
          <qb-ita-footer *ngIf="footerLinks?.length" [footerLinks]="footerLinks"></qb-ita-footer>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #coveragesLite>
  <qb-ita-coverage-summary-lite
    [headerTitle]="homeProject?.branchDesc"
    [headerSubtitle]="homeTypeName | uppercase"
    [priceValue]="
      homeProject?.premiumPaymentModality?.paymentModalityTypeCode === 'everyyear'
        ? homeProject?.premiumPaymentModality?.totalAmn
        : homeProject?.premiumPaymentModality?.discountedAmn
    "
    [priceCurrencyIsoCode]="
      homeProject?.premiumPaymentModality?.paymentModalityTypeCode === 'everyyear'
        ? homeProject?.premiumPaymentModality?.totalCurrencyIsoCode
        : homeProject?.premiumPaymentModality?.discountedCurrencyIsoCode
    "
    [priceYearLabel]="priceLabel | translate"
    [editLabel]="'COVERAGES_LITE.EDIT_BUTTON' | translate"
    editIcon="verti-edit-16"
    (editBtnClick)="summaryLiteOnEditBtnClick.emit()"
    [coveragesTitle]="'COVERAGES_LITE.COVERAGE_LABEL' | translate"
    [coverages]="summaryLiteSimpleCoverages"
    iconSuccess="verti-success"
    iconCollapse="verti-arrow-simple-up-16"
    [oldPriceValue]="
      homeProject?.premiumPaymentModality?.paymentModalityTypeCode !== 'everyyear'
        ? homeProject?.premiumPaymentModality?.totalAmn
        : undefined
    "
    [oldPriceCurrencyIsoCode]="
      homeProject?.premiumPaymentModality?.paymentModalityTypeCode !== 'everyyear'
        ? homeProject?.premiumPaymentModality?.totalCurrencyIsoCode
        : undefined
    "
    [oldPriceYearLabel]="'COVERAGES_LITE.PRICE.YEAR' | translate"
    [modality]="homeProject?.premiumPaymentModality?.paymentModalityTypeCode"
  >
  </qb-ita-coverage-summary-lite>
</ng-template>

<ng-template #alert>
  <qb-ita-discount-alert
    type="success"
    icon="verti-saving"
    [label]="
      'COVERAGES_LITE.ALERT_DISCOUNT'
        | translate
          : {
              discountedPrice:
                homeProject?.premiumDiscountAmn?.savedAmn?.totSavedAmn
                | currency: homeProject?.premiumDiscountAmn?.savedAmn?.currencyIsoCode
            }
    "
  ></qb-ita-discount-alert>
</ng-template>

<ng-template #backButton let-hideTextMobile="hideTextMobile">
  <qb-ita-back-button
    class="layout__back-button"
    *ngIf="!hideBackButton"
    [title]="backBtnTitle || ('BACK_BUTTON.TITLE' | translate)"
    (back)="backBtnClick.emit()"
    [hideTextMobile]="hideTextMobile"
    arrowLeftIcon="verti-arrow-simple-left-16"
  ></qb-ita-back-button>
</ng-template>
